<template>
  <div class="row align-center servicobiblio" id="servicos">
    <div class="columns small-12 medium-12 large-9">
        <div class="centerContent">
            <p class="carouselTitle">{{ $t('UMA_LANG_SASUMA_SERVICOSSAS') }}</p>
            <span class="curso_linha3 azul_site_background"></span>
        </div>
        <div class="row servicosList" data-equalizer>
            <router-link v-for="servico in servicos"
                class="small-12 medium-6 large-4 columns servicoitem"
                :to="servico.to" >
                <div class="content" data-equalizer-watch>
                    <img :src="servico.icon"/>
                    <p>{{servico.title}}</p>
                    <span v-html="servico.desc"></span>
                </div>
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
import { i18n } from '@/main.js';

import alojamento from '@/assets/images/SAS_icon-16.png';
import alimentacao from '@/assets/images/SAS_icon-17.png';
import bolsas from '@/assets/images/SAS_icon-18.png';

export default {
  setup () {

    const { t } = i18n.global;
    
    const servicos = [
      { 
        'title' : t("UMA_LANG_SASUMA_HOMEMENU_ALOJAMENTO"),
        'desc' : t("servicos.UMA_LANG_SASUMA_HOME_SERVICOS_ALOJAMENTO_DESCRICAO"),
        'icon' : alojamento,
        'to' : '/alojamento',
      },
      {
        'title' : t("UMA_LANG_SASUMA_HOMEMENU_ALIMENTACAO"),
        'desc' : t("servicos.UMA_LANG_SASUMA_HOME_SERVICOS_ALIMENTACAO_DESCRICAO"),
        'icon' : alimentacao,
        'to' : '/alimentacao',
      },
      {
        'title' : t("UMA_LANG_SASUMA_HOMEMENU_BOLSAS"),
        'desc' : t("servicos.UMA_LANG_SASUMA_HOME_SERVICOS_BOLSA_DESCRICAO"),
        'icon' : bolsas,
        'to' : '/bolsasdeestudo',
      }
    ];

    return {
      servicos
    }
  }
}
</script>

<style lang="scss" scoped>
.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.carouselTitle {
  font-family: 'Montserrat Bold';
  font-size: 30px;
  margin-top: 0px;
  color: #333333;
  display: inline-block;
  margin-bottom: 5px;
  padding-top: 85px;
}

.carouselTitle {
    padding-top: 85px;
}

.curso_linha3 {
  height: 3px;
  display: block;
  width: 150px;
  margin-bottom: 85px;
}

.curso_linha3 {
  margin-bottom: 50px;
}

/*#region Servicos*/
.servicobiblio{
    background-color: #f0f0f3;
}

.servicosList{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 87px;
}

/*primeiro*/
.servicoitem:nth-of-type(3n-2){
    padding-right: 0;
}

/*terceiro*/
.servicoitem:nth-of-type(3n){
    padding-left: 0;
}

.servicoitem .content{
    padding: 30px 30px 60px;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 15px;
}


.cinza_fundo {
    background-color: #f0f0f3!important;
}

.bibliotecafaq {
    background-color: #f0f0f3!important;
}

.servicoitem .content:hover {
    box-shadow: 0 2.8px 2.2px rgb(0 0 0 / 1%), 0 6.7px 5.3px rgb(0 0 0 / 2%),
    0 12.5px 10px rgb(0 0 0 / 2%), 0 22.3px 17.9px rgb(0 0 0 / 2%),
    0 41.8px 33.4px rgb(0 0 0 / 3%), 0 100px 80px rgb(0 0 0 / 4%);
}

.servicoitem p {
    font-family: "Montserrat";
    margin-bottom: 10px;
    font-size: 19px;
    color: rgb(10, 10, 10);
}

.servicoitem img {
  width: 57px;
  margin-bottom: 5px;
  margin-top: 8px;
}

.servicoitem span {
  font-family: "PT Sans";
  font-size: 15px;
  display: block;
  text-align: center;
  color: #454648;
}

@media (max-width: 1024px) {
  .carouselTitle {
    font-size: 23px;
    padding-top: 50px;
  }
}

@media (max-width: 1023px) {
  .servicosList .servicoitem:nth-of-type(3){
    padding-right: 0px;
    padding-left: 15px;
  }
}

@media (max-width: 767px) {

  .carouselTitle {
    padding-top: 50px;
  }

  .carouselTitle {
    font-size: 19px;
  }  

  .curso_linha3 {
    margin-bottom: 30px;
  }

  .servicoitem p {
    margin-bottom: 0px;
    font-size: 16px;
  }

  .servicoitem span {
    font-size: 14px;
  }

  .servicoitem .content {
    padding: 10px 10px 20px;
  }

   /*primeiro*/
  .servicoitem:nth-of-type(3n-2){
    padding-right: .625rem;
  }

  /*terceiro*/
  .servicoitem:nth-of-type(3n){
    padding-left: .625rem;
  }

}

</style>